import { useFormContext, useController } from "react-hook-form";
import React from "react";
import { RadioTile } from "./RadioTile";
import { Question } from "./types";
import { PaziaInput } from "components/atoms/PaziaInput/PaziaInput";

interface SurveyPreviewSelectListProps {
  question: Question;
  onChange: (values: string[]) => void;
  isMulti: boolean;
}

interface PaziaSurveyPreviewSelectListProps
  extends Omit<SurveyPreviewSelectListProps, "onChange"> {
  onChange?: (values: string[]) => void;
  name: string;
}

export const PaziaSurveyPreviewSelectList = ({
  onChange,
  name,
  ...rest
}: PaziaSurveyPreviewSelectListProps): JSX.Element => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control,
  });

  const onChangeHandler = (vals: string[]) => {
    field.onChange(vals);
    if (onChange) onChange(vals);
  };

  return <SurveyPreviewSelectList onChange={onChangeHandler} {...rest} />;
};

export const SurveyPreviewSelectList = ({
  question,
  isMulti,
  onChange,
}: SurveyPreviewSelectListProps) => {
  const [selected, setSelected] = React.useState<string[]>([]);

  const onChangeHandler = (id: string, value: boolean) => {
    if (isMulti) {
      if (value)
        setSelected((pv) => {
          onChange([...pv, id]);
          return [...pv, id];
        });
      else
        setSelected((pv) => {
          onChange(pv.filter((item) => item !== id));
          return pv.filter((item) => item !== id);
        });
    } else {
      onChange([id]);
      setSelected([id]);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      {question.options?.map((option) => (
        <RadioTile
          key={option.id}
          value={selected.includes(option.id)}
          onChange={(val) => onChangeHandler(option.id, val)}
        >
          {option.value}
        </RadioTile>
      ))}
      {selected.includes("-1") && (
        <PaziaInput
          placeholder="Inne..."
          name="other"
          label="Wymień"
          required
        />
      )}
    </div>
  );
};
